<template>
  <div class="home-page-container">
    <!-- Hero Section -->
    <section class="hero-section">
      <div class="hero-inner">
        <p class="hero-eyebrow">GLOBAL AI LINK LIMITED</p>
        <h1 class="hero-title">
          Global AI Digital Marketing<br class="title-break" />
          Technology Provider
        </h1>
        <p class="hero-subtitle">
          Specialized in overseas ad campaigns, AI traffic optimization, Search
          Arbitrage, LeadGen, cross-platform UA development &amp; programmatic
          advertising technical solutions.
        </p>

        <div class="hero-visual">
          <div class="hero-visual-frame">
            <img
              src="../../static/images/globalai_home.png"
              alt="Global AI network illustration"
            />
          </div>
        </div>
      </div>
    </section>

    <!-- Company Overview -->
    <section class="company-overview-section">
      <div class="section-container overview-grid">
        <div class="overview-visual">
          <div class="overview-visual-frame">
            <img
              src="../../static/images/globalai001.webp"
              alt="Global AI technology illustration"
            />
          </div>
        </div>
        <div class="overview-content">
          <h2 class="overview-title">Company Overview</h2>
          <p class="overview-text">
            GLOBAL AI LINK LIMITED is a Hong Kong registered AI technology
            enterprise. We focus on global mobile advertising, Meta &amp; CTV
            media buying, and traffic tracking system development — delivering
            full-stack AI marketing solutions for overseas businesses worldwide.
          </p>
          <p class="overview-text">
            Our in-house development team builds proprietary ad tracking tools
            and auto-bidding systems, with full capacity for iOS &amp; Android
            app development and global commercial operation.
          </p>
          <ul class="overview-highlights">
            <li v-for="item in overviewHighlights" :key="item">
              <svg class="highlight-icon" width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 22C17.5 22 22 17.5 22 12C22 6.5 17.5 2 12 2C6.5 2 2 6.5 2 12C2 17.5 6.5 22 12 22Z" fill="rgba(75, 137, 255, 0.1)"/>
                <path d="M16 8L10.5 14L8 11.5" stroke="#4b89ff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
              <span>{{ item }}</span>
            </li>
          </ul>
        </div>
      </div>
    </section>

    <!-- Core Services -->
    <section class="core-services-section">
      <div class="section-container">
        <div class="section-head">
          <span class="section-label section-label--center">What We Do</span>
          <h2 class="section-title">Core Services Preview</h2>
          <p class="section-desc">
            Full-stack AI marketing and technology capabilities for global
            brands, from traffic acquisition to conversion optimization.
          </p>
        </div>
        <div class="services-grid">
          <article
            v-for="(service, index) in coreServices"
            :key="service.title"
            class="service-card"
          >
            <span class="service-index">{{
              String(index + 1).padStart(2, "0")
            }}</span>
            <h3>{{ service.title }}</h3>
            <p>{{ service.desc }}</p>
          </article>
        </div>
      </div>
    </section>

    <!-- Partners Section -->
    <section class="partners-section">
      <div class="section-container">
        <div class="section-head section-head--compact">
          <span class="section-label section-label--center">Partnerships</span>
          <h2 class="section-title">Supported Platforms</h2>
        </div>
        <div class="partner-logos-marquee">
          <div class="partner-logos-track">
            <div class="partner-logos-row">
              <div
                v-for="logo in partnerLogos"
                :key="logo"
                :class="['logo-item', logo]"
              ></div>
            </div>
            <div class="partner-logos-row" aria-hidden="true">
              <div
                v-for="logo in partnerLogos"
                :key="'dup-' + logo"
                :class="['logo-item', logo]"
              ></div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Qualifications Section -->
    <section class="roles-section">
      <div class="section-container">
        <div class="section-head section-head--compact">
          <span class="section-label section-label--center">Credentials</span>
          <h2 class="section-title">Enterprise Qualification</h2>
        </div>
        <div class="qualifications-gallery">
          <div class="qualification-image-card">
            <img
              src="../../static/images/GlobalAILinkLimited1.png"
              alt="Global AI Link Limited Qualification 1"
            />
          </div>
          <div class="qualification-image-card">
            <img
              src="../../static/images/lGlobalAILinkLimited2.png"
              alt="Global AI Link Limited Qualification 2"
            />
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: "HomePage",
  data() {
    return {
      overviewHighlights: [
        "Hong Kong registered AI technology enterprise",
        "Meta, CTV & global media buying expertise",
        "Proprietary ad tracking & auto-bidding systems",
        "Full iOS & Android app development capacity",
      ],
      coreServices: [
        {
          title: "AI Programmatic Ad Optimization",
          desc: "AI-powered bidding, audience targeting and campaign automation across Meta, TikTok, CTV and other global ad platforms.",
        },
        {
          title: "Search Arbitrage",
          desc: "Advanced RSOC/AFS strategies and data-driven optimization to maximize search traffic quality and RPM performance.",
        },
        {
          title: "LeadGen",
          desc: "High-quality lead generation across Home Services, Nutra, Sweepstakes and performance verticals with scalable media-buy operations.",
        },
        {
          title: "Overseas App Development & App Store Launch",
          desc: "Native iOS and Android development with full App Store compliance, from UI design to publishing and long-term operation support.",
        },
        {
          title: "Cross-channel Traffic Attribution System Deployment",
          desc: "Self-built tracking and attribution systems integrated with Voluum, Clickflare and major ad platforms for accurate campaign analytics.",
        },
        {
          title: "Full-Spectrum Digital Marketing for Global Brands",
          desc: "End-to-end cross-border marketing solutions covering strategy, creative, media buying, optimization and sustainable growth.",
        },
      ],
      partnerLogos: [
        "graph",
        "sedo",
        "t-logo",
        "system1",
        "obmedia",
        "clickdealer",
        "exploreads",
        "flex",
        "interesrmedia",
        "inuvo",
        "leadsmarket",
        "moxxi",
        "nutra",
        "point2web",
        "predicto",
      ],
    };
  },
};
</script>

<style scoped>
ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

h1,
h2,
h3,
p {
  margin: 0;
  padding: 0;
}

.home-page-container {
  font-family: "Poppins", -apple-system, BlinkMacSystemFont, "Segoe UI",
    "Roboto", "Helvetica Neue", Arial, sans-serif;
  color: #1c2b4e;
  background-color: #f5f8fc;
  overflow-x: hidden;
}

.section-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

.section-label {
  display: inline-block;
  margin-bottom: 12px;
  padding: 6px 14px;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 1.4px;
  text-transform: uppercase;
  color: #4b89ff;
  background: rgba(75, 137, 255, 0.1);
  border-radius: 999px;
}

.section-label--center {
  display: table;
  margin-left: auto;
  margin-right: auto;
}

.section-head {
  text-align: center;
  max-width: 720px;
  margin: 0 auto 52px;
}

.section-head--compact {
  margin-bottom: 44px;
}

.section-title {
  font-size: 40px;
  font-weight: 700;
  color: #1c2b4e;
  line-height: 1.2;
}

.section-head .section-title::after {
  content: "";
  display: block;
  width: 72px;
  height: 4px;
  margin: 18px auto 0;
  background: linear-gradient(90deg, #4b89ff, #296dff);
  border-radius: 2px;
}

.section-desc {
  margin-top: 18px;
  font-size: 16px;
  line-height: 1.75;
  color: #64748b;
}

/* Hero */
.hero-section {
  position: relative;
  padding: 150px 20px 72px;
  background-image: url("../../static/images/publisher/hero-bg.jpg");
  background-size: cover;
  background-position: center top;
  background-attachment: fixed;
  background-repeat: no-repeat;
  overflow: hidden;
}

.hero-section::before {
  content: "";
  position: absolute;
  inset: 0;
  background: linear-gradient(
    180deg,
    rgba(240, 247, 255, 0.35) 0%,
    rgba(245, 248, 252, 0.92) 100%
  );
  pointer-events: none;
}

.hero-inner {
  position: relative;
  z-index: 1;
  max-width: 960px;
  margin: 0 auto;
  text-align: center;
}

.hero-eyebrow {
  margin-bottom: 16px;
  font-size: 13px;
  letter-spacing: 1.8px;
  font-weight: 700;
  color: #4b89ff;
}

.hero-title {
  font-size: 52px;
  font-weight: 700;
  color: #1c2b4e;
  margin-bottom: 22px;
  line-height: 1.15;
  letter-spacing: -0.5px;
}

.title-break {
  display: none;
}

.hero-subtitle {
  font-size: 18px;
  line-height: 1.8;
  color: #475569;
  max-width: 820px;
  margin: 0 auto 48px;
}

.hero-visual {
  position: relative;
  width: 100%;
  max-width: 820px;
  margin: 4px auto 0;
}

.hero-visual::after {
  content: "";
  position: absolute;
  left: 50%;
  bottom: -16px;
  width: 72%;
  height: 48px;
  transform: translateX(-50%);
  background: radial-gradient(
    ellipse at center,
    rgba(75, 137, 255, 0.22) 0%,
    transparent 72%
  );
  pointer-events: none;
  z-index: 0;
}

.hero-visual-frame {
  position: relative;
  z-index: 1;
  /* border-radius: 150px 60px 150px 60px; */
  overflow: hidden;
  /* background: linear-gradient(135deg, #e8f1ff 0%, #ffffff 100%); */
  /* box-shadow: 0 20px 48px rgba(28, 43, 78, 0.1),
    0 0 0 1px rgba(75, 137, 255, 0.1); */
}

/* .hero-visual-frame::before {
  content: "";
  position: absolute;
  inset: 0;
  border: 1px solid rgba(75, 137, 255, 0.14);
  border-radius: 20px;
  pointer-events: none;
  z-index: 2;
} */

.hero-visual-frame img {
  width: 100%;
  max-width: 800px;
  height: auto;
  display: block;
  margin: 0 auto;

  /* border-radius: 20px 0px 20px 0px; */
}

/* Company Overview */
.company-overview-section {
  position: relative;
  padding: 88px 0;
  background-image: url("../../static/images/publisher/hero-bg.jpg");
  background-size: cover;
  background-position: center;
  background-attachment: fixed;
  background-repeat: no-repeat;
}

.company-overview-section::before {
  content: "";
  position: absolute;
  inset: 0;
  background: linear-gradient(
    90deg,
    rgba(255, 255, 255, 0.94) 0%,
    rgba(240, 247, 255, 0.88) 50%,
    rgba(255, 255, 255, 0.92) 100%
  );
  pointer-events: none;
}

.overview-grid {
  position: relative;
  z-index: 1;
  display: grid;
  grid-template-columns: 1fr 1.1fr;
  gap: 56px;
  align-items: center;
  max-width: 1140px;
}

.overview-visual {
  display: flex;
  justify-content: center;
  align-items: center;
}

.overview-visual-frame {
  position: relative;
  border-radius: 24px;
  overflow: hidden;
  box-shadow: 0 16px 48px rgba(28, 43, 78, 0.08);
  background: linear-gradient(135deg, #f0f7ff 0%, #ffffff 100%);
  width: 100%;
  max-width: 480px;
}

.overview-visual-frame::after {
  content: "";
  position: absolute;
  inset: 0;
  border: 1px solid rgba(75, 137, 255, 0.12);
  border-radius: 24px;
  pointer-events: none;
}

.overview-visual-frame img {
  width: 100%;
  height: auto;
  display: block;
}

.overview-content {
  text-align: left;
}

.overview-title {
  margin: 0 0 20px;
  font-size: 36px;
  font-weight: 700;
  line-height: 1.25;
  color: #1c2b4e;
  letter-spacing: -0.3px;
}

.overview-title::after {
  content: "";
  display: block;
  width: 48px;
  height: 3px;
  margin-top: 14px;
  background: linear-gradient(90deg, #4b89ff, #296dff);
  border-radius: 2px;
}

.overview-text {
  margin: 0 0 16px;
  font-size: 16px;
  line-height: 1.85;
  color: #475569;
}

.overview-text:last-of-type {
  margin-bottom: 24px;
}

.overview-highlights {
  list-style: none;
  margin: 0;
  padding: 0;
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 16px 20px;
}

.overview-highlights li {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  font-size: 15px;
  line-height: 1.6;
  color: #334155;
  font-weight: 500;
}

.highlight-icon {
  flex-shrink: 0;
  margin-top: 2px;
}

/* Core Services */
.core-services-section {
  position: relative;
  padding: 100px 0 110px;
  text-align: center;
  overflow: hidden;
  background-color: #f0f8ff;
  background-image: url("../../static/images/publisher/xbj.png");
  background-size: 100% 100%;
  background-position: center center;
  background-repeat: no-repeat;
}

.core-services-section .section-container {
  position: relative;
  z-index: 1;
}

.services-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 28px;
  max-width: 1100px;
  margin: 0 auto;
}

.service-card {
  position: relative;
  padding: 32px 28px 28px;
  background: #ffffff;
  border: 1px solid rgba(75, 137, 255, 0.08);
  border-radius: 20px;
  box-shadow: 0 10px 32px rgba(28, 43, 78, 0.04);
  text-align: left;
  transition: transform 0.3s ease, box-shadow 0.3s ease, border-color 0.3s ease;
}

.service-card:hover {
  transform: translateY(-5px);
  border-color: rgba(75, 137, 255, 0.2);
  box-shadow: 0 16px 40px rgba(75, 137, 255, 0.1);
}

.service-index {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  margin-bottom: 20px;
  font-size: 15px;
  font-weight: 700;
  color: #4b89ff;
  background: linear-gradient(135deg, rgba(75, 137, 255, 0.12) 0%, rgba(75, 137, 255, 0.02) 100%);
  border-radius: 12px;
  letter-spacing: 0.5px;
}

.service-card h3 {
  margin-bottom: 12px;
  font-size: 19px;
  font-weight: 700;
  line-height: 1.35;
  color: #1c2b4e;
}

.service-card p {
  font-size: 15px;
  line-height: 1.75;
  color: #64748b;
}

/* Partners */
.partners-section {
  padding: 88px 0 96px;
  background: linear-gradient(135deg, #eaf2ff 0%, #f5f8fc 100%);
  border-radius: 48px 48px 0 0;
}

.partner-logos-marquee {
  width: 100%;
  overflow: hidden;
  -webkit-mask-image: linear-gradient(
    to right,
    transparent,
    #000 6%,
    #000 94%,
    transparent
  );
  mask-image: linear-gradient(
    to right,
    transparent,
    #000 6%,
    #000 94%,
    transparent
  );
}

.partner-logos-track {
  display: flex;
  width: max-content;
  animation: partner-marquee 45s linear infinite;
}

.partner-logos-marquee:hover .partner-logos-track {
  animation-play-state: paused;
}

.partner-logos-row {
  display: flex;
  align-items: center;
  gap: 50px;
  padding: 0 25px;
}

@keyframes partner-marquee {
  from {
    transform: translateX(0);
  }
  to {
    transform: translateX(-50%);
  }
}

.logo-item {
  flex-shrink: 0;
  width: 120px;
  height: 120px;
  border-radius: 15px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-size: 70%;
  background-repeat: no-repeat;
  background-position: center;
  transition: transform 0.3s ease;
}

.logo-item:hover {
  transform: scale(1.06);
}

/* Specific background images and colors for each logo.
   You need to extract these images and place them in '/static/images/logos/'.
*/
.facebook {
  background-image: url("../../static/images/icons/fb.png");
  background-color: transparent;
}
.instagram {
  background-image: url("../../static/images/icons/ins.png");
  background-color: transparent;
}
.tiktok {
  background-image: url("../../static/images/icons/tt.png");
  background-color: transparent;
}
.graph {
  background-image: url("../../static/images/icons/m.png");
  background-color: transparent;
} /* The green graph icon */
.sedo {
  background-image: url("../../static/images/icons/sedo.png");
  background-color: transparent;
} /* Black background for sedo */
.t-logo {
  background-image: url("../../static/images/icons/tonic.png");
  background-color: transparent;
}
.system1 {
  background-image: url("../../static/images/icons/system1.png");
  background-color: transparent;
} /* Black background for system1 */
.obmedia {
  background-image: url("../../static/images/icons/b media.png");
  background-color: transparent;
} /* Black background for obmedia */
.clickdealer {
  background-image: url("../../static/images/icons/clickdealer.png");
  background-color: transparent;
}
.exploreads {
  background-image: url("../../static/images/icons/ExploreAds.png.png");
  background-color: transparent;
}
.flex {
  background-image: url("../../static/images/icons/flex.png");
  background-color: transparent;
}
.interesrmedia {
  background-image: url("../../static/images/icons/interesrMedia-logo.png");
  background-color: transparent;
}
.inuvo {
  background-image: url("../../static/images/icons/inuvo-logo.png");
  background-color: transparent;
}
.leadsmarket {
  background-image: url("../../static/images/icons/leadsmarket.png");
  background-color: transparent;
}
.moxxi {
  background-image: url("../../static/images/icons/Moxxi.png");
  background-color: transparent;
}
.nutra {
  background-image: url("../../static/images/icons/nutra.png");
  background-color: transparent;
}
.point2web {
  background-image: url("../../static/images/icons/point2web.png");
  background-color: transparent;
}
.predicto {
  background-image: url("../../static/images/icons/Predicto.png");
  background-color: transparent;
}

/* Qualifications */
.roles-section {
  padding: 88px 0 100px;
  background-color: #f5f8fc;
}

.qualifications-gallery {
  display: grid;
  grid-template-columns: repeat(2, minmax(280px, 1fr));
  gap: 32px;
}

.qualification-image-card {
  background-color: #fff;
  border-radius: 18px;
  padding: 16px;
  border: 1px solid rgba(75, 137, 255, 0.1);
  box-shadow: 0 10px 30px rgba(28, 43, 78, 0.08);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.qualification-image-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 16px 40px rgba(28, 43, 78, 0.12);
}

.qualification-image-card img {
  display: block;
  width: 100%;
  height: auto;
  border-radius: 12px;
}

/* Responsive */
@media (max-width: 1200px) {
  .hero-title {
    font-size: 44px;
  }

  .services-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (max-width: 992px) {
  .hero-section {
    padding-top: 120px;
    padding-bottom: 56px;
  }

  .hero-title {
    font-size: 36px;
  }

  .title-break {
    display: block;
  }

  .hero-subtitle {
    font-size: 16px;
    margin-bottom: 36px;
  }

  .company-overview-section {
    padding: 64px 0;
  }

  .overview-grid {
    grid-template-columns: 1fr;
    gap: 36px;
    text-align: center;
  }

  .overview-content {
    text-align: center;
  }

  .overview-title::after {
    margin-left: auto;
    margin-right: auto;
  }

  .overview-highlights {
    grid-template-columns: 1fr;
    max-width: 420px;
    margin: 0 auto;
    text-align: left;
  }

  .overview-visual-frame {
    max-width: 400px;
    margin: 0 auto;
  }

  .overview-title {
    font-size: 28px;
  }

  .section-title {
    font-size: 32px;
  }

  .core-services-section,
  .partners-section,
  .roles-section {
    padding: 64px 0;
  }

  .core-services-section {
    background-size: 100% 100%;
  }

  .services-grid {
    max-width: 95%;
  }

  .partner-logos-row {
    gap: 30px;
  }

  .partner-logos-track {
    animation-duration: 35s;
  }

  .qualifications-gallery {
    grid-template-columns: 1fr;
    max-width: 640px;
    margin: 0 auto;
  }
}

@media (max-width: 768px) {
  .hero-section {
    padding-top: 100px;
    padding-bottom: 40px;
  }

  .hero-title {
    font-size: 30px;
  }

  .hero-subtitle,
  .overview-text {
    font-size: 15px;
  }

  .hero-visual {
    margin-top: 0;
    padding: 0 10px;
    box-sizing: border-box;
  }

  .section-title {
    font-size: 28px;
  }

  .services-grid {
    grid-template-columns: 1fr;
  }

  .core-services-section {
    padding: 48px 0 56px;
    background-size: 100% 100%;
  }

  .partner-logos-row {
    gap: 20px;
  }

  .logo-item {
    width: 100px;
    height: 100px;
  }

  .partner-logos-track {
    animation-duration: 30s;
  }
}

@media (max-width: 480px) {
  .hero-title {
    font-size: 26px;
  }

  .overview-title {
    font-size: 24px;
  }

  .overview-highlights li {
    font-size: 13px;
  }

  .service-card {
    padding: 22px 20px;
  }

  .partners-section {
    border-radius: 32px 32px 0 0;
  }

  .partner-logos-row {
    gap: 16px;
    padding: 0 12px;
  }

  .logo-item {
    width: 80px;
    height: 80px;
    border-radius: 10px;
  }

  .partner-logos-track {
    animation-duration: 25s;
  }

  .qualifications-gallery {
    gap: 18px;
  }

  .qualification-image-card {
    padding: 10px;
  }
}
</style>
